export const iconDictionary = {
    info: 'falInfoCircle',
    warning: 'falExclamationTriangle',
    error: 'falExclamationTriangle',
    success: 'falCheckCircle'
};
export const spacingDictionary = {
    sm: 4,
    md: 6,
    lg: 8,
    xl: 10
};
export const messageColors = {
    info: 'seaBlue.main',
    warning: 'terracotta.30',
    error: 'energyRed.45',
    success: 'landGreen.35'
};
